import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/authActions";

import logo from "../../assets/images/logo-navbar.png";

const navLinkConfig = {
  public: [
    { to: "/", label: "Home" },
    { to: "/login", label: "Login" },
    { to: "/register", label: "Register" },
    { to: "/resetpassword", label: "Reset Password" },
  ],
  student: [
    { to: "/appointments", label: "Appointments" },
    { to: "/profile", label: "Profile" },
  ],
  instructor: [
    { to: "/appointments", label: "Calendar" },
    { to: "/sessionlogs", label: "Session Logs" },
    { to: "/profile", label: "Profile" },
  ],
  admin: [
    { to: "/users", label: "Users" },
    { to: "/payroll", label: "Payroll" },
    { to: "/appointments", label: "Appointments" },
    { to: "/sessionlogs", label: "Session Logs" },
    { to: "/profile", label: "Profile" },
  ],
};

const NavLinks = ({ active, links, onLogout, showLogout }) => {
  return (
    <>
      {links.map(({ to, label }) => (
        <Link
          key={to}
          className={`nav-link ${active === to && "active"}`}
          to={to}
        >
          {label}
        </Link>
      ))}
      {showLogout && (
        <a className="nav-link" href="#!" onClick={onLogout}>
          Logout
        </a>
      )}
    </>
  );
};

const Header = () => {
  const {
    isAuthenticated,
    profile: { config = { role: "" } },
  } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const location = useLocation();
  const active = location.pathname;

  const handleLogout = () => {
    dispatch(logout());
  };

  const role = isAuthenticated ? config.role : "public";
  const links = navLinkConfig[role] ?? [];
  const showLogout = role !== "public";

  return (
    <Navbar bg="primary" variant="dark" collapseOnSelect expand="sm">
      <Link className="navbar-brand" to="/">
        <img src={logo} width="85" alt="Logo" />
      </Link>
      <Navbar.Toggle aria-controls="navbar" />
      <Navbar.Collapse id="navbar">
        <Nav className="ml-auto">
          <NavLinks
            active={active}
            links={links}
            onLogout={handleLogout}
            showLogout={showLogout}
          />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
